import React, { Fragment, useContext, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { reduxForm, Field } from 'redux-form';
import { ButtonToolbar, Button, Label, Collapse } from 'reactstrap';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import ReportOffIcon from '@material-ui/icons/ReportOff';
import ReportIcon from '@material-ui/icons/Report';
import {
  alertDayAccountAvailable,
  alertDayAccountSaveMutation,
  alertDayByAccount,
  applyDiscountConfigurationMutation,
  bankListByFilter,
  discountConfigurationByAccount,
} from '../../../shared/queries/Account';
import validate from './Validate';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import renderField from '../../../shared/components/form/RenderField';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import Select from '../../../shared/components/form/Select';
import AddressInfo from '../../../shared/components/form/AddressInfo';
import GraphQL from '../../../GraphQL';
import {
  cpfMasker,
  cnpjMasker,
  currencyMasker,
} from '../../../shared/components/form/Masks';
import AccountTypeSelector from '../../../shared/components/form/AccountTypeSelector';
import { ACCEPTED, SMART_BABY_USER } from '../../../shared/utils/constants';
import FullScreenDialog from '../../../shared/components/FullScreenDialog';
import DiscountConfiguration from '../../../shared/components/DiscountConfiguration';
import AlertConfigurationForm from './AlertConfiguration';
import SmartContext from '../../App/context/SmartContext';

const SmartPayForm = (props) => {
  const {
    t,
    backHandler,
    handleSubmit,
    dto,
    initialize,
    change,
    showLoading,
    hideLoading,
  } = props;
  const [automaticWithdrawal, setAutomaticWithdrawal] = useState(false);
  const [listOfBanks, setListOfBanks] = useState([]);
  const [masker, setMaskers] = useState({});
  const valueDiscountEachtitle = 128;
  const [discountEachtitle, setDiscountEachtitle] = useState(
    valueDiscountEachtitle
  );
  const [discountConfigurationForm, setDiscountConfigurationForm] =
    useState(false);
  const [alertConfigurationForm, setAlertConfigurationForm] = useState(false);
  const [discountConfigurations, setDiscountConfigurations] = useState([]);
  const [alertConfigurations, setAlertConfigurations] = useState([]);
  const [alertList, setAlertList] = useState([]);
  const context = useContext(SmartContext);
  const { loggedUser } = context;
  const [userEdit, setUserEdit] = useState(false);

  const toggleDiscountConfigurationForm = () => {
    setDiscountConfigurationForm(!discountConfigurationForm);
  };

  const toggleAlertConfigurationForm = () => {
    setAlertConfigurationForm(!alertConfigurationForm);
  };

  const discountEachtitleChange = (value) => {
    if (value >= 0 && value <= 999) {
      const updatedDisocunt = (valueDiscountEachtitle + value) / 100;
      setDiscountEachtitle(updatedDisocunt);
    }
  };
  const loadAllBank = () => {
    const filter = { filterByStatus: true, active: true, updaterId: 0 };
    const query = bankListByFilter(filter);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.bankListByFilter = res.bankListByFilter.map((item) => ({
          ...item,
          value: parseInt(item.id, 10),
          label: item.name,
        }));
        setListOfBanks(res.bankListByFilter);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAlertConfigurations = (accountId) => {
    const query = alertDayByAccount(accountId);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        setAlertConfigurations(res.alertDayByAccount);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadAllAlert = () => {
    const query = alertDayAccountAvailable();
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        res.alertDayAccountAvailable = res.alertDayAccountAvailable.map(
          (item) => ({
            ...item,
            value: item.alertDay,
            label: t(`setting-expiration-alerts.${item.alertDay}`),
          })
        );
        setAlertList(res.alertDayAccountAvailable);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const loadDiscountsConfigurations = (accountId) => {
    const query = discountConfigurationByAccount(accountId);
    showLoading();
    GraphQL(query, {})
      .then((res) => {
        setDiscountConfigurations(res.discountConfigurationByAccount);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      });
  };

  const saveDiscountConfigurations = (list, changed) => {
    toggleDiscountConfigurationForm();
    if (changed) {
      const query = applyDiscountConfigurationMutation(dto.id, list);
      showLoading();
      GraphQL(query, {})
        .then(() => {
          hideLoading();
          setDiscountConfigurations(list);
          showNotificationAutoDestroy(
            'success',
            t('success.title'),
            t('success.successfully-saved')
          );
        })
        .catch(() => {
          hideLoading();
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        });
    }
  };

  const saveAlertList = (list, chenged) => {
    toggleAlertConfigurationForm();
    if (chenged) {
      const query = alertDayAccountSaveMutation(dto.id, list);
      showLoading();
      GraphQL(query, {})
        .then(() => {
          hideLoading();
          setAlertConfigurations(list);
          showNotificationAutoDestroy(
            'success',
            t('success.title'),
            t('success.successfully-saved')
          );
        })
        .catch(() => {
          hideLoading();
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        });
    }
  };

  useEffect(() => {
    initialize(dto);
    discountEachtitleChange(dto.bankSlipCommission);
    if (dto.autoWithDraw) {
      setAutomaticWithdrawal(!automaticWithdrawal);
    }
    if (loggedUser.login.toUpperCase() === SMART_BABY_USER) {
      setUserEdit(!userEdit);
    }
  }, [dto]);

  useEffect(() => {
    loadAllBank();
    loadDiscountsConfigurations(dto.id);
    loadAlertConfigurations(dto.id);
    loadAllAlert();
  }, []);

  return (
    <Fragment>
      <FullScreenDialog
        title={t('panels.discounts-setup')}
        toggleDialog={toggleDiscountConfigurationForm}
        isOpen={discountConfigurationForm}
      >
        <DiscountConfiguration
          discountConfigurations={discountConfigurations}
          onConfirm={saveDiscountConfigurations}
          forTitle={false}
          accountId={dto.id}
          onConfirmMessage="effectuation-configuration-new-titles-generated"
        />
      </FullScreenDialog>
      <FullScreenDialog
        title={t('panels.alerts-setup')}
        toggleDialog={toggleAlertConfigurationForm}
        isOpen={alertConfigurationForm}
      >
        <AlertConfigurationForm
          alerts={alertList}
          alertsConfigurations={alertConfigurations}
          accountId={dto.id}
          onConfirm={saveAlertList}
          userEdit={userEdit}
        />
      </FullScreenDialog>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('account.holder')}</span>
          <div className="form__form-group-field">
            <Field
              name="companyName"
              type="text"
              component={renderField}
              maxLength="100"
              placeholder={t('account.placeholders.holder')}
              disabled={!userEdit}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('account.cnpj')}</span>
          <div className="form__form-group-field">
            <Field
              name="cnpj"
              type="text"
              component={renderField}
              placeholder={t('account.placeholders.cnpj')}
              {...cnpjMasker()}
              disabled={!userEdit}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('account.responsible-account')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="respName"
              type="text"
              component={renderField}
              maxLength="100"
              placeholder={t('account.placeholders.responsible')}
              disabled={!userEdit}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('account.responsible-cpf')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="respCpf"
              type="text"
              component={renderField}
              placeholder={t('account.placeholders.cpf')}
              {...cpfMasker()}
              disabled={!userEdit}
            />
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('account.account-type')}
            </span>
            <div className="form_form-group-field">
              <Field
                name="accountType"
                component={AccountTypeSelector}
                color="primary"
                isDisabled={!userEdit}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('account.bank')}</span>
            <div className="form_form-group-field">
              <Field
                name="bank"
                type="text"
                component={Select}
                options={listOfBanks}
                onChange={(options) =>
                  setMaskers({
                    agencyPattern: options.agencyPattern,
                    accountPattern: options.accountPattern,
                  })
                }
                placeholder={t('account.placeholders.select')}
                isDisabled={!userEdit}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('account.agency')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="bankAgency"
                type="text"
                component={renderField}
                maxLength="100"
                placeholder={masker.agencyPattern || t('account.agency')}
                disabled={!userEdit}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('account.account')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="banckCc"
                type="text"
                component={renderField}
                maxLength="100"
                placeholder={masker.accountPattern || t('account.account')}
                disabled={!userEdit}
              />
            </div>
          </div>
        </div>
        <AddressInfo
          t={t}
          showLoading={showLoading}
          hideLoading={hideLoading}
          change={change}
          hideFields={{
            cellPhone: true,
            cellPhoneAux: true,
            neighborhood: true,
            addressAdjunct: true,
          }}
          disabled={!userEdit}
        />
        <div className="form__form-group--2_columns">
          <div className="form__form-group-field">
            <Label className="form__form-group-label pr-2">
              {t('account.interest')}
            </Label>
            <Field
              name="dailyInterestForDelay"
              component={renderCheckBoxField}
              className="colored-click"
              disabled={!userEdit}
            />
          </div>
          <div className="form__form-group-field">
            <Label className="form__form-group-label pr-2">
              {t('account.penalty')}
            </Label>
            <Field
              name="interestForDelay"
              component={renderCheckBoxField}
              className="colored-click"
              disabled={!userEdit}
            />
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('account.fine-amount')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="interestRateForDelay"
                type="number"
                component={renderField}
                placeholder={t('account.placeholders.cash-out-value')}
                disabled={!userEdit}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('account.lugu-name')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="iuguAccountName"
              type="text"
              component={renderField}
              placeholder={t('account.placeholders.lugu-name')}
              readOnly
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('account.lugu-id')}</span>
          <div className="form__form-group-field">
            <Field
              name="iuguId"
              type="text"
              component={renderField}
              placeholder={t('account.placeholders.lugu-id')}
              readOnly
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('account.live-token')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="iuguLiveToken"
              type="text"
              component={renderField}
              placeholder={t('account.placeholders.live-token')}
              readOnly
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('account.test-token')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="iuguTestToken"
              type="text"
              component={renderField}
              placeholder={t('account.placeholders.test-token')}
              readOnly
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('account.user-token')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="userToken"
              type="text"
              component={renderField}
              placeholder={t('account.placeholders.user-token')}
              readOnly
            />
          </div>
        </div>
        <div className="form__form-group-field">
          <Label className="form__form-group-label pr-2">
            {t('account.automatic')}
          </Label>
          <Field
            name="autoWithDraw"
            component={renderCheckBoxField}
            className="colored-click"
            onChange={(event) => {
              if (event.target) {
                setAutomaticWithdrawal(event.target.checked);
              }
            }}
            disabled={!userEdit}
          />
        </div>

        <Collapse isOpen={!automaticWithdrawal} className="width100">
          <div className="form__form-group--2_columns pt-3">
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('account.free-withdrawals')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="numberWithdrawals"
                  type="number"
                  min="0"
                  max="99"
                  component={renderField}
                  placeholder={t('account.placeholders.free-withdrawals')}
                  disabled={!userEdit}
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">
                {t('account.cash-out-value')}
              </span>
              <div className="form__form-group-field">
                <Field
                  name="extraWithdrawalAmount"
                  type="text"
                  component={renderField}
                  placeholder={t('account.placeholders.cash-out-value')}
                  {...currencyMasker()}
                  disabled={!userEdit}
                />
              </div>
            </div>
          </div>
        </Collapse>
        <div className="form__form-group pt-2">
          <span className="form__form-group-label">
            {t('account.commission')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="bankSlipCommission"
              type="number"
              min="0"
              max="999"
              component={renderField}
              onBlur={(evt) =>
                discountEachtitleChange(parseInt(evt.target.value, 10))
              }
              placeholder={t('account.placeholders.commission')}
              disabled={!userEdit}
            />
          </div>
          <span className="form__form-group-label pt-3 text-danger">
            {t('account.values-info')}
            {discountEachtitle.toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </span>
        </div>
        <div className="form__form-group-field">
          <Label className="form__form-group-label pr-2">
            {t('account.active')}
          </Label>
          <Field
            name="active"
            component={renderCheckBoxField}
            className="colored-click"
            disabled={!userEdit}
          />
        </div>
        <div className="form__form-group-field pt-2">
          <div className="form__form-group-label">
            {t('account.verification-status')}
            <Label className="font-weight-bold text-center pl-2">
              {dto.verificationStatus === ACCEPTED ? (
                <>
                  {dto.verificationStatus} <ReportIcon className="pb-1" />
                </>
              ) : (
                <>
                  {dto.verificationStatus} <ReportOffIcon className="pb-1" />
                </>
              )}
            </Label>
          </div>
        </div>

        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" onClick={backHandler}>
            {t('general.back')}
          </Button>
          <Button
            disabled={!userEdit}
            color="warning"
            onClick={() => toggleAlertConfigurationForm()}
          >
            {t('general.alerts')}
          </Button>
          <Button
            disabled={!userEdit}
            color="secondary"
            onClick={() => toggleDiscountConfigurationForm()}
          >
            {t('general.discounts')}
          </Button>
          <Button disabled={!userEdit} color="success" type="submit">
            {t('general.save')}
          </Button>
        </ButtonToolbar>
      </form>
    </Fragment>
  );
};

SmartPayForm.propTypes = {
  t: PropTypes.func.isRequired,
  backHandler: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  showLoading: PropTypes.func.isRequired,
  hideLoading: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default reduxForm({
  form: 'SmartPayForm',
  validate,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(SmartPayForm));
